import { SVGIconComponent } from './types';

export const ChannelPortal: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="15px"
    height="26px"
    viewBox="0 0 15 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Channel/Portal" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M12.750072,6 C13.9924462,6 15,6.970268 15,8.16666667 L15,16.8333333 C15,18.029732 13.9924462,19 12.750072,19 L2.249928,19 C1.00755376,19 0,18.029732 0,16.8333333 L0,8.16666667 C0,6.970268 1.00755376,6 2.249928,6 L12.750072,6 Z M13.0540705,10.0099222 L1.99408806,10.0099222 L1.99408806,16.2759865 C1.99408806,16.6747919 2.32947133,16.9984399 2.74360208,16.9984399 L12.3045565,16.9984399 C12.7186873,16.9984399 13.0540705,16.6747919 13.0540705,16.2759865 L13.0540705,10.0099222 Z M11,12.5 C11.5522847,12.5 12,12.9477153 12,13.5 C12,14.0522847 11.5522847,14.5 11,14.5 L8,14.5 C7.44771525,14.5 7,14.0522847 7,13.5 C7,12.9477153 7.44771525,12.5 8,12.5 L11,12.5 Z M9.749928,7.44421333 C9.33579725,7.44421333 8.99971201,7.76786133 8.99971201,8.16666667 C8.99971201,8.565472 9.33579725,8.88912 9.749928,8.88912 C10.1640588,8.88912 10.500144,8.565472 10.500144,8.16666667 C10.500144,7.76786133 10.1640588,7.44421333 9.749928,7.44421333 Z M11.999856,7.44421333 C11.5857253,7.44421333 11.24964,7.76786133 11.24964,8.16666667 C11.24964,8.565472 11.5857253,8.88912 11.999856,8.88912 C12.4139868,8.88912 12.750072,8.565472 12.750072,8.16666667 C12.750072,7.76786133 12.4139868,7.44421333 11.999856,7.44421333 Z"
        id="Combined-Shape"
        fill="#979797"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
